(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voicsky-mega-menu"] && !Shopify.designMode) return;
  try {
    
  class VoicskyMegaTabs extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.voicsky-mega-panel__tiles').forEach((tiles) => {
        const items = [...tiles.querySelectorAll('.voicsky-mega-panel__tile')];
        const visible = items.filter((tile) => window.voicskyIsMarketVisible?.(tile) !== false);
        if (visible.length === items.length) return;
        items.filter((tile) => !visible.includes(tile)).forEach((tile) => tile.remove());
        tiles.dataset.tileCount = String(visible.length);
      });
      this.addEventListener('pointerover', this.#activate);
      this.addEventListener('focusin', this.#activate);
      this.addEventListener('click', this.#activate);
    }

    #activate = (event) => {
      const tab = event.target.closest('[data-mega-tab]');
      if (!tab || !this.contains(tab)) return;
      const id = tab.dataset.megaTab;
      const selected = tab.getAttribute('aria-selected') === 'true';
      const hasUrl = tab instanceof HTMLAnchorElement && tab.getAttribute('href');
      if (event.type === 'click' && (!selected || !hasUrl)) event.preventDefault();
      if (selected) return;
      this.querySelectorAll('[data-mega-tab]').forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.megaTab === id)));
      this.querySelectorAll('[data-mega-content]').forEach((panel) => {
        const active = panel.dataset.megaContent === id;
        panel.hidden = !active;
        if (active && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panel.getAnimations().forEach((animation) => animation.cancel());
          panel.animate(
            [{ opacity: .9, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 150, easing: 'cubic-bezier(.22,.61,.36,1)' }
          );
        }
      });
    };
  }

  if (!customElements.get('voicsky-mega-tabs')) customElements.define('voicsky-mega-tabs', VoicskyMegaTabs);

  const mountVoicskyMobileMegaMenus = () => {
    const menu = document.querySelector('.voicsky-mobile-drawer-menu');
    if (!menu) return;
    const enabledTriggers = new Set((menu.dataset.voicskyMegaTriggers || '').split(/\s+/).filter(Boolean));
    const panels = [...document.querySelectorAll('.voicsky-mega-panel[data-voicsky-mega-position]')];
    menu.querySelectorAll('[data-mobile-mega-trigger]').forEach((details) => {
      const panel = panels.find((candidate) => candidate.dataset.voicskyMegaKey === details.dataset.mobileMegaTrigger);
      if (panel && enabledTriggers.has(panel.dataset.voicskyMegaTrigger) &&
          panel.dataset.voicskyMegaPosition === details.dataset.mobileMegaPosition) return;
      details.parentElement.querySelector('.voicsky-mobile-mega-original-trigger')?.classList.remove('voicsky-mobile-mega-original-trigger');
      details.remove();
    });
    document.querySelectorAll('.voicsky-mega-panel[data-voicsky-mega-position]').forEach((panel) => {
      if (!enabledTriggers.has(panel.dataset.voicskyMegaTrigger)) return;
      const stableKey = panel.dataset.voicskyMegaKey;
      const position = Number(panel.dataset.voicskyMegaPosition);
      const sourceLayout = panel.querySelector('.voicsky-mega-panel__layout');
      if (!stableKey || !position || !sourceLayout) return;

      const existing = document.querySelector(`.voicsky-mobile-drawer-menu [data-mobile-mega-position="${position}"]`);
      if (existing) return;

      const topLevelItems = document.querySelectorAll('.voicsky-mobile-drawer-menu > li');
      const listItem = topLevelItems[position - 1];
      const drawerTrigger = listItem?.querySelector('.voicsky-mobile-drawer-link');
      if (!drawerTrigger || !listItem) return;

      const label = drawerTrigger.querySelector('.menu-drawer__menu-item-text')?.textContent?.trim() || 'Mega menu';
      const details = document.createElement('details');
      details.className = 'voicsky-mobile-mega-details';
      details.dataset.mobileMegaTrigger = stableKey;
      details.dataset.mobileMegaPosition = String(position);

      const summary = document.createElement('summary');
      summary.className = 'voicsky-mobile-drawer-link voicsky-mobile-drawer-summary focus-inset';
      const summaryLabel = document.createElement('span');
      summaryLabel.className = 'menu-drawer__menu-item-text';
      summaryLabel.textContent = label;
      const summaryIcon = document.createElement('span');
      summaryIcon.className = 'voicsky-mobile-mega-details__icon';
      summaryIcon.setAttribute('aria-hidden', 'true');
      summaryIcon.innerHTML = '<svg viewBox="0 0 24 24"><path d="m9.4 18.4-1.4-1.4 5-5-5-5 1.4-1.4 6.4 6.4-6.4 6.4Z" fill="currentColor"/></svg>';
      summary.append(summaryLabel, summaryIcon);

      const content = document.createElement('div');
      content.className = 'voicsky-mobile-mega-content';
      content.style.cssText = panel.style.cssText;
      const backButton = document.createElement('button');
      backButton.className = 'voicsky-mobile-mega-back';
      backButton.type = 'button';
      backButton.setAttribute('aria-label', panel.dataset.backTo.replace('__title__', () => label));
      backButton.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="m14.7 18.3-6.3-6.3 6.3-6.3 1.4 1.4-4.9 4.9 4.9 4.9-1.4 1.4Z" fill="currentColor"/></svg><span></span>';
      backButton.querySelector('span').textContent = panel.dataset.backLabel;
      content.append(backButton);
      content.append(sourceLayout.cloneNode(true));

      details.append(summary, content);
      drawerTrigger.classList.add('voicsky-mobile-mega-original-trigger');
      listItem.append(details);
    });
  };

  mountVoicskyMobileMegaMenus();
  document.addEventListener('shopify:section:load', mountVoicskyMobileMegaMenus);

  const mobileDrawerRoot = document.querySelector('#Details-menu-drawer-container');
  if (mobileDrawerRoot && !mobileDrawerRoot.hasAttribute('data-voicsky-mega-observed')) {
    mobileDrawerRoot.setAttribute('data-voicsky-mega-observed', 'true');
    const mobileDrawerObserver = new MutationObserver(() => {
      window.requestAnimationFrame(mountVoicskyMobileMegaMenus);
    });
    mobileDrawerObserver.observe(mobileDrawerRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-voicsky-mega-triggers'] });
  }

  } catch(e) { console.error(e); }
})();
})();
